export default __webpack_public_path__ + "static/35-5c037b08d352d639168c6f5a418e257c.png";